<template>
  <v-container>
    <v-row>
      <v-col cols="8" offset="2">
        <v-row>
          <v-col align="center">
            <PageTitle title="メンテナンスのお知らせ" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <MessageBox>
              日頃よりNishikaをご利用いただき、誠にありがとうございます。<br/>
              現在システムメンテナンスのため、こちらのページはご利用いただけません。<br/>
              <br/>
              メンテナンスの期間は「2024年7月12日（火）16：00〜17：00」を予定しておりますが、延長される可能性があります。<br/>
              ご不便をお掛け致しますが、ご理解いただきますようお願い申し上げます。
            </MessageBox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from "@/components/atoms/PageTitle";
import MessageBox from "@/components/atoms/MessageBox";
export default {
  name: "MaintenancePage",
  components: {MessageBox, PageTitle}
}
</script>

<style scoped>

</style>
